import React from 'react';
import { FileText } from 'lucide-react';
import { hasPartnerWorkReport } from '../../utils/handoffSettlementUtils';

const PartnerCompletionReport = ({ job }) => {
  if (!hasPartnerWorkReport(job)) return null;

  const report = job.report || {};

  return (
    <div className="mb-2 pb-2 border-b border-gray-600 space-y-2">
      <p className="text-[10px] font-semibold text-gray-300 flex items-center gap-1">
        <FileText className="h-3 w-3" />
        Izveštaj partnera
      </p>

      {job.issueDescription && (
        <div>
          <span className="text-gray-400 block text-[10px] mb-0.5">Prijavljeni kvar:</span>
          <p className="text-white text-[10px] whitespace-pre-wrap">{job.issueDescription}</p>
        </div>
      )}

      {report.workDescription && String(report.workDescription).trim() && (
        <div>
          <span className="text-gray-400 block text-[10px] mb-0.5">Šta je popravljeno:</span>
          <p className="text-white text-[10px] whitespace-pre-wrap font-medium">
            {report.workDescription}
          </p>
        </div>
      )}

      {report.materialsUsed && String(report.materialsUsed).trim() && (
        <div>
          <span className="text-gray-400 block text-[10px] mb-0.5">Korišćeni materijali:</span>
          <p className="text-white text-[10px] whitespace-pre-wrap">{report.materialsUsed}</p>
        </div>
      )}

      {report.additionalNotes && String(report.additionalNotes).trim() && (
        <div>
          <span className="text-gray-400 block text-[10px] mb-0.5">Napomene:</span>
          <p className="text-white text-[10px] whitespace-pre-wrap">{report.additionalNotes}</p>
        </div>
      )}
    </div>
  );
};

export default PartnerCompletionReport;
